class QuickSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.listeners.add(document, 'click', this.handleTrigger.bind(this))

    this.listeners.add(
      document,
      'DOMContentLoaded',
      this.enableSearchTrigger.bind(this),
    )
  }

  enableSearchTrigger () {
    this.externalEls.trigger.element.removeAttribute('disabled')
  }

  handleTrigger (e) {
    const dropdownInner = e.target.closest('.klv-QuickSearch_DropdownInner')
    const externalTrigger = e.target.closest(
      '[data-quick-search-external-el="trigger"]',
    )

    if (!dropdownInner && !externalTrigger) {
      this.removeAttribute('data-active')
      this.removeAttribute('aria-expanded')
      document.body.classList.remove('util-Search-open')
      return
    }

    const isExpanded = this.getAttribute('aria-expanded') === 'true'

    if (isExpanded && !dropdownInner) {
      this.removeAttribute('data-active')
      this.removeAttribute('aria-expanded')
      document.body.classList.remove('util-Search-open')
    } else {
      this.setAttribute('data-active', 'true')
      this.setAttribute('aria-expanded', 'true')
      document.body.classList.add('util-Search-open')
    }

    if (this.els?.input?.exists === false) return

    const interval = setInterval(() => {
      if (this.els.input.element === document.activeElement) {
        clearInterval(interval)
      }
      this.els.input.element.focus()
    }, 100)
  }
}

if (!customElements.get('quick-search')) {
  customElements.define('quick-search', QuickSearch)
}
